<template>
  <div class="permissinoStat-container app-container">
    <div class="permissinoStat-header">
      <TabHeader
        :slideData="slideData"
        :tab="tab"
        @headerTabBack="headerTabBack"
      ></TabHeader>
    </div>
    <div class="permissinoStat-filter">
      <el-card shadow="always" :body-style="{ padding: '20px' }">
        <div class="permissinoStat-filter-main">
          <div class="permissinoStat-filter-left">
            <el-date-picker
              v-model="currentDate"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeDate"
            >
            </el-date-picker>
            <el-select
              style="margin-left:15px;"
              v-model="currentModel"
              filterable
              clearable
              @change="changeModel"
              placeholder="设备型号选择"
            >
              <el-option
                v-for="item in modelData"
                :key="item._id"
                :label="item.model"
                :value="item.model"
              >
              </el-option>
            </el-select>
          </div>
          <div class="permissinoStat-filter-right">
            <div class="permissionStat-date-select">
              <span
                v-for="item in dateType"
                :key="item.type"
                class="permissionStat-date-select-item"
                :class="{
                  'permissionStat-date-select-active': type === item.type
                }"
                @click="changeType(item.type)"
                >{{ item.label }}</span
              >
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="permissinoStat-main" v-bar>
      <div>
        <template v-for="item in chartData">
          <div :key="item.name" v-if="item.name === tab">
            <el-card shadow="always" :body-style="{ padding: '20px' }">
              <el-row :gutter="20">
                <el-col :span="12">
                  <span class="permissinoStat-header-label">总共人数：</span>
                  <span class="permissinoStat-header-value">{{
                    item.totalUser
                  }}</span>
                </el-col>
                <el-col :span="12">
                  <span class="permissinoStat-header-label">总共用量：</span>
                  <span class="permissinoStat-header-value">{{
                    item.totalCount
                  }}</span>
                </el-col>
              </el-row>
            </el-card>
            <div
              class="permissinoStat-barChart"
              v-for="(data, index) in item.datas"
              :key="index"
            >
              <LibraryBarChart :xAxisData="item.dates" :statData="data" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import TabHeader from '@/components/tabHeader'
import LibraryBarChart from './components/libraryBarChart.vue'
import Search from '@/components/listSearch'
export default {
  components: {
    TabHeader,
    LibraryBarChart
  },
  computed: {},
  data() {
    return {
      dateType: [
        {
          type: 'day',
          label: '天'
        },
        {
          type: 'week',
          label: '周'
        },
        {
          type: 'month',
          label: '月'
        },
        {
          type: 'year',
          label: '年'
        }
      ],
      tab: '',
      currentModel: '',
      type: 'day',
      currentDate: '',
      modelData: [],
      slideData: [],
      chartData: [],
      params: {
        dateType: 'day',
        model: '',
        endTime: ''
      }
    }
  },
  methods: {
    headerTabBack(tab) {
      this.tab = tab.component
    },
    async getDevicesModelList() {
      try {
        let res = await this.$http.getDevicesModelList({
          limit: 10000,
          page: 1,
          sortBy: 'updatedAt'
        })
        this.modelData = res.data.results
      } catch (error) {}
    },
    changeModel() {
      this.params.model = this.currentModel
      this.getStatData()
    },
    changeDate() {
      this.params.endTime = this.currentDate
      this.getStatData()
    },
    changeType(type) {
      if (this.type === type) return
      this.type = type
      this.params.dateType = type
      this.getStatData()
    },
    async getStatData() {
      let res = await this.$http.getPermissionStat(this.params)
      this.chartData = res.data ? res.data.data : null
      if (!this.chartData) return
      let slideData = []
      for (let item of this.chartData) {
        slideData = [...slideData, { name: item.text, component: item.name }]
      }
      this.slideData = slideData
      if (!this.tab) {
        this.tab = this.slideData[0].component
      }
    }
  },
  mounted() {
    this.getDevicesModelList()
    this.getStatData()
  }
}
</script>

<style lang="scss" scoped>
.permissinoStat-container {
  .permissinoStat-filter {
    margin: 15px 20px;
    .permissinoStat-filter-main {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .permissinoStat-filter-left {
        display: flex;
        align-items: center;
      }
    }
    .permissionStat-date-select {
      .permissionStat-date-select-item {
        display: inline-block;
        padding: 6px 12px;
        margin-left: 15px;
        font-size: 14px;
        border-radius: 4px;
        border: none;
        outline: none;
        cursor: pointer;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        background: #ccc;
        color: #fff;
      }
      .permissionStat-date-select-active {
        background: #bf735b;
        color: #fff;
      }
    }
  }
  .permissinoStat-main {
    padding: 0 20px 20px;
    .permissinoStat-header-label {
      font-weight: bold;
    }
    .permissinoStat-header-value {
      font-weight: bold;
      color: red;
    }
    .permissinoStat-barChart {
      margin-top: 15px;
    }
  }
}
</style>
